import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import { injectGlobal } from "styled-components";
import Header from "../Header";
import Footer from "../Footer";
import Forgot from "../../pages/Forgot";
import Reset from "../../pages/Reset";

injectGlobal`
  * {
    box-sizing: border-box;
  }

  body {
    background: #181543;
    font-family: 'Lato', sans-serif;
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
  	-moz-osx-font-smoothing: grayscale;
  }

  #root {
    overflow: hidden;
  }
`;

const App = () => (
  <Router>
    <div>
      <Header />
      <Switch>
        <Route exact path="/" component={Forgot} />
        <Route path="/reset-password" component={Reset} />
        <Redirect to="/" />
      </Switch>
      <Footer />
    </div>
  </Router>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/App/index.jsx